/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number1SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path fill="white" d="M15.2 24.35V12.23L12.45 15.06L10.42 12.93L15.68 7.64999H18.78V24.35H15.2Z" />
	</>
);

export default Number1SansDark;
